import React, { Component } from 'react';
// import '../App.css';
import "./style/style.scss"
import { Button, Checkbox, Form, Input, Select, message } from 'antd'
import { downloadLink, IcaLoginDto, initState, IState } from "./State";
import LoginBackg from "./img/loginbackg.jpg"
import BackTop from "./img/bcTop.png"
import BackBottom from "./img/bottom.png"
import swap from "./img/swap.svg"
import user from "./img/Frame (2).svg"
import lock from "./img/Frame (3).svg"
import ca from "./img/ca.svg"
import pin from "./img/pin.svg"
import { styled } from 'styled-components';
import { Service } from './Service';
import HunanCA from "../framework/utils/HuNanCALib/api";
import BeijingCA from "../framework/utils/BeijingCALib/Login/api"
import BeijingCAAsync from "../framework/utils/BeijingCALib/Login/xtxasyn"

interface IProps {
  form: any;
}

const CAType = [
  // { type: "湖南CA" },
  {type: "湖南省公共资源CA共享平台" },
];

const { Option } = Select



class App extends Component<IProps, IState> {
  state = initState;
  service = new Service();

  componentDidMount() {
    this.init();
    // this.setRegisterInfo()
  }

  async init() {
    this.setAccount();
  }

  setAccount = () => {
    const { setFieldsValue } = this.props.form;
    const localAccount = localStorage.getItem("account");
    if (localAccount) {
      const account = JSON.parse(localAccount);
      setFieldsValue(account);
    }
  };

  handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      this.handleLogin(e);
    }
  };

  loginMessage = () => {
    const { loginMessage } = this.state;
    return <p style={{ color: "#ED1717" }}>{loginMessage}</p>;
  };

  /**记住密码公告 */
  rememberThePassword = (values: any) => {
    if (values.checked) {
      localStorage.setItem("account", JSON.stringify(values));
    } else {
      values.password = "";
      localStorage.setItem("account", JSON.stringify(values));
    }
  };

  handleLogin = (e: any) => {
    this.props.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        this.setState({
          btnLoading: true
        });
        const data = await this.service.login(values).finally(() => {
          this.setState({
            btnLoading: false
          });
        });
        if (data.isOk === true) {
          const { access_token, refresh_token, token_type } = data.loginData
          this.rememberThePassword(values);
          window.open(`https://ebs.hbncp.com.cn/out/login?access_token=${access_token}&refresh_token=${refresh_token}&token_type=${token_type}`, '_self')
          return;
        } else {
          this.setState({
            messageVisible: true,
            loginMessage: data.msg
          });
          message.error(data.msg);
        }
      } else {
        message.warning("请按照正确格式填写信息！");
      }
    });


  };


  /**检测ca 并登录*/
  checkCABeforeLogin = () => {
    const { validateFields } = this.props.form;
    validateFields(async (err: any, values: any) => {
      if (!err) {
        switch (this.state.caWay) {
          // case 0:
          //   this.loginByHuNanCA(values);
          //   return;
          case 0:
            this.loginByBeijingCA(values);
        }
      } else {
      }
    });
  };

  loginByHuNanCA = async (values: any) => {
    // 生成随机6位数字符串作为待签原文
    const randomStr = Math.random()
      .toString(36)
      .substr(2, 6);
    let caInfo = await HunanCA.getCALoginInfo(randomStr, values.pin);
    if (caInfo.code !== 0) {
      message.warn(caInfo.msg);
      this.setState({
        CAState: 2
      });
      return;
    }

    const dto: any = {
      ...((caInfo.data as unknown) as object),
      grant_type: "ca",
      scope: "server",
      data: randomStr
    };

    this.executeCALogin(dto);
  };

  loginByBeijingCA = async(values: any) => {
    // 北京ca
    // 初始化北京ca 建立ws连接
    BeijingCAAsync.initXtxAsyn()
    BeijingCAAsync.initXtxAppComObject()

    /** 获取certId */
    const certInfo: any = await BeijingCA.getUserList()
    if (certInfo.code !== 0) {
      message.warn(certInfo.msg);
      this.setState({
        CAState: 2
      })
      return;
    }

    const certId = certInfo.data

    /**校验pin码 */
    const pinInfo = await BeijingCA.test_SOF_Login(certId, values.pin)
    if (pinInfo.code !== 0) {
      message.warn(pinInfo.msg);
      return;
    }
    const signData = await BeijingCA.randomSignData(certId)
    const userCert = await BeijingCA.getUserCert(certId)

    const dto = {
      ...signData.data,
      secret: userCert.data,
      key: certId.split("/")[1],
      grant_type: "ca",
      scope: "server"
    };
    this.executeCALogin(dto)
  }

  executeCALogin = async (dto: IcaLoginDto) => {
    const data = await this.service.caLogin(dto);
    if (data.isOk === true) {
      const { access_token, refresh_token, token_type } = data.loginData
      window.open(`https://ebs.hbncp.com.cn/out/login?access_token=${access_token}&refresh_token=${refresh_token}&token_type=${token_type}`, '_self')
      return;
    } else {
      message.error(data.msg);
    }
  };

  // 登录方式切换
  loginWayToggle(index: number) {
    this.setState({
      currentLoginWay: index
    });
    if (index === 1) {
      this.setState({
        caWay: 0
      });
    }
  }

  /* 切换ca登录方式 */
  handleSelectChange = (value: number) => {
    console.log(value);
    this.setState({
      caWay: value
    });
  };

  public render() {
    const { getFieldDecorator } = this.props.form;
    const { currentLoginWay, CAState, btnLoading } = this.state;

    return (
      <div className="eLogin">
        <img className="bgimg" src={LoginBackg} alt=''/>
        <div
          style={{ marginBottom: "40px" }}
          className="wrapper"
        >
          <div
            className="box"
          >
            <img className="bcTop" src={BackTop} alt="bcTop" />
            <img className="bcBottom" src={BackBottom} alt="bcBottom" />
            <div className="loginbox">
              <ul
                style={{
                  marginBottom: "40px"
                }}
                className="logintab"
              >
                <li
                  className="active"
                >
                  后台登录
                </li>
              </ul>

              {/* 登陆表单 账号登录*/}
              {currentLoginWay === 1 && (
                <Form className="loginform">
                  <UserName>
                    {getFieldDecorator("username", {
                      initialValue: "",
                      rules: [{ required: true, message: "请输入用户名" }]
                    })(
                      <Input
                        className="InputUserName"
                        size="large"
                        addonBefore={<img src={user} alt="" />}
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入账号"
                      />
                    )}
                  </UserName>

                  <PassWord>
                    {getFieldDecorator("password", {
                      initialValue: "",
                      rules: [{ required: true, message: "请输入密码" }]
                    })(
                      <Input.Password
                        key={1}
                        className="InputPassword"
                        size="large"
                        addonBefore={<img src={lock} alt='' />}
                        type="password"
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入密码"
                      />
                    )}
                  </PassWord>

                  {/* 错误提示 */}
                  {this.loginMessage()}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <Remember>
                      {getFieldDecorator("checked", {
                        initialValue: false,
                        rules: [{ required: false }]
                      })(<Checkbox>记住账号</Checkbox>)}
                    </Remember>
                    <div style={{ zIndex: 999, color: '#555' }} className="forget">
                      {/* <Link
                            to={{
                              pathname: "/out/forget",
                              search: "?place=cz" // 可选参数
                            }}
                          >
                            忘记密码
                          </Link> */}
                      <a style={{ color: '#555' }} href="https://ebs.hbncp.com.cn/out/forget">忘记密码</a>
                    </div>
                  </div>
                  <Button
                    style={{
                      background: "#3D559B",
                      marginTop: "25px"
                    }}
                    type="primary"
                    size="large"
                    block={true}
                    onClick={this.handleLogin}
                    loading={btnLoading}
                  >
                    登录
                  </Button>
                </Form>
              )}
              {/* 登陆表单 CA登录*/}
              {currentLoginWay === 2 && (
                <Form className="loginform ca">
                  <CAInput label="请选择使用的CA" className="caWay">
                    {getFieldDecorator("type", {
                      rules: [{ required: true, message: "请选择使用的CA" }],
                      initialValue: CAType[0].type
                    })(
                      <Select {...{size: 'large', onChange: this.handleSelectChange }}>
                          {CAType.map((item, index) => <Option key={index} value={index}>{item.type}</Option>
                          )}
                        </Select>
                    )}
                  </CAInput >
                  <PinInput label="请填写PIN码" className="pinInput">
                  {getFieldDecorator("pin", {
                      initialValue: "",
                      rules: [{ required: true, message: "请填写PIN码" }]
                    })(<Input.Password size="large" onKeyDown={this.handleKeyDown} placeholder="请填写PIN码" />)}
                  </PinInput>
                  {CAState === 2 && (
                    <div className="ukey-fail">
                      {/* <Icon type="info-circle" theme="filled" /> */}
                      <p>未检测到您的U-Key，请重新插入</p>
                    </div>
                  )}

                  {
                    <a href={downloadLink[this.state.caWay].link} style={{ position: "relative" }}>
                      {downloadLink[this.state.caWay].title}
                    </a>
                  }
                  <Button
                    style={{
                      background: "#3D559B"
                    }}
                    type="primary"
                    size="large"
                    block={true}
                    onClick={this.checkCABeforeLogin}
                  >
                    检测CA并登录
                  </Button>
                </Form>
              )}
              {/* 登录方式 */}
              {(
                <>
                  <ul className="loginway-toggle">
                    <li style={{ alignItems: 'flex-start' }}>
                      {/* <Icon style={{ marginRight: "5px" }} type="swap" /> */}
                      <img src={swap} alt="" />
                      切换登录方式:
                    </li>
                    <li onClick={() => this.loginWayToggle(1)} className="way by-account">
                      账号登录
                    </li>
                    <li onClick={() => this.loginWayToggle(2)} className="way by-ca">
                      CA锁登陆
                    </li>
                    {/* <li className='way'>
                        <img src={"/img/yiguLogin/weixinlogin.png"} alt="" />
                        微信登录</li> */}
                  </ul>
                  <ul className="go_register">
                    <a
                      className="go"
                      href="http://222.240.80.14:8888/G2/gfm/login.do?systemId=4028c7b35a8cfff2015a8df8bba001fc"
                    >
                      去注册
                    </a>
                  </ul>
                </>
              )}
            </div>
            <div className='ca_tip'>
                    <p>1、自2023年12月1日起，新用户应通过湖南省统一注册平台进行注册，注册完成及后续可直接通过统一注册平台内可直接跳转至本平台进行后续操作；</p>
                    <p>2、新用户可通过统一注册平台进行在线ca办理或在郴州市公共资源交易中心现场办理CA，CA办理成后可在我平台进行绑定。</p>
                  </div>
            {/* <img className='yigulogo' src={"/img/yiguLogin/yigulogo.png"} alt="" /> */}
          </div>
          {
            <div className="bottominfo">
              <div className="bottomtop">
                <span>服务热线：400-112-9919</span>
                <span className="line">|</span>
                <span>技术中心：武汉市洪山区青菱大道648号东湖高新德成科创中心1-302</span>
                <span className="line">|</span>
                <span>运营中心：黄冈市黄州区东门路39号</span>
              </div>
              <div className="bottomdown">
                <span>Copyright © 2020</span>
                <span className="line">|</span>
                <span>www.hbncp.com.cn</span>
                <span className="line">|</span>
                <span>鄂ICP备16010688号</span>
                <span className="line">|</span>
                <span>鄂公网安备 42011102003672号</span>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//       </header>
//     </div>
//   );
// }

const AppForm = Form.create<IProps>()(App);
export default AppForm;

const Remember = styled(Form.Item)`
  margin-bottom: 0;
`

const UserName = styled(Form.Item)`
  margin-bottom: 32px;

  .ant-input-group-addon {
    border-radius: 4px 0px 0px 4px;
    background: rgba(120, 151, 242, 0.16);
    img {
      vertical-align: middle;
    }
  }
  
`
const PassWord = styled(Form.Item)`
  margin-bottom: 0;
  .ant-input-group-addon {
    border-radius: 4px 0px 0px 4px;
    background: rgba(120, 151, 242, 0.16);
    img {
      vertical-align: middle;
    }
  }
  
`

const CAInput = styled(Form.Item)`
.ant-select-selection__rendered .ant-select-selection-selected-value::before {
  content: url(${ca});
  position: relative;
  top: 3px;
  margin-right: 7px;
}
.ant-select-selection-selected-value {
  color: #777777;
}
`

const PinInput = styled(Form.Item)`
.ant-form-item-control .ant-form-item-children::before {
  content: url(${pin});
  position: absolute;
  z-index: 9999999;
  top: -5px;
  left: 10px;
}
.ant-input-lg {
  padding-left: 37px;
  color: #777777;
}
`
